import { useEffect, useState } from 'react';

/**
 * @param {string} paramName
 * @returns {string | null}
 */
export const useQueryParam = (paramName) => {
    const [value, setValue] = useState(() => {
        return new URLSearchParams(window.location.search).get(paramName);
    });

    useEffect(() => {
        const handler = () => {
            setValue(new URLSearchParams(window.location.search).get(paramName));
        };
        window.addEventListener('popstate', handler);
        return () => window.removeEventListener('popstate', handler);
    }, [paramName]);

    return value;
};